<template>
  <b-navbar fixed-top type="is-primary" wrapper-class="container">
    <template slot="brand">
      <b-navbar-item tag="div" class="mr-4">
        <router-link to="/app">
          <strong class="has-text-white is-size-4">thread</strong>
        </router-link>
      </b-navbar-item>
      <b-navbar-item v-show="$store.state.app.loading" class="navbar-loader">
        <div class="loader"></div>
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" to="/app/compose">
        <b-icon icon="pen-fancy" />
        <span>Compose</span>
      </b-navbar-item>

      <b-navbar-item tag="router-link" to="/app/drafts">
        <b-icon icon="drafting-compass" />
        <span>Drafts <b-tag v-if="$store.getters.nonEmptyThreadCount" type="is-info is-light" size="is-small" rounded>{{ $store.getters.nonEmptyThreadCount }}</b-tag></span>
      </b-navbar-item>

      <b-navbar-item tag="router-link" to="/app/outbox"
        :class="{ 'is-disabled': !isLoggedIn }">
        <b-icon icon="calendar-day" />
        <span>Outbox</span>
      </b-navbar-item>

      <b-navbar-item
          tag="router-link" to="/app/recent"
          :class="{ 'is-disabled': !isLoggedIn }">
        <b-icon icon="history"/>
        <span>Recent</span>
      </b-navbar-item>

      <b-navbar-item
          tag="router-link" to="/app/timelines"
          :class="{ 'is-disabled': !isLoggedIn }">
        <b-icon icon="list"/>
        <span>Timelines</span>
      </b-navbar-item>

    </template>
    <template slot="end">
      <account-login/>
    </template>
  </b-navbar>
</template>
<script>

import AccountLogin from "../../components/AccountLogin";
import {mapGetters} from "vuex";

export default {
  name: 'NavBar',
  components: {
    AccountLogin
  },
  computed: mapGetters(['isLoggedIn']),
}
</script>


<style lang="scss">

.navbar-item .icon {
  margin-right: 0.5em;
}

a.navbar-item.is-disabled {
  pointer-events: none;
  opacity: .25;
}

.navbar-loader {
  position: absolute;
  left: calc(50% - 1rem);
  top: calc(50% - 1rem);
}
</style>
